<template>
    <ul id="sections-menu">
        <li class="sections-list" v-for="(s, index) in sections" :key="index">
            <div
                class="section-link"
                @click="jump(s)"
                :class="activeIndex === index ? 'active' : ''"
            >
                {{s.name}}
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    name:'SectionsMenu',
    data() {
        return {
            activeIndex: 0,     // the activated section's index
            sections: []        // the sections
        }
    },
    methods: {
        // set the current sections
        setSections(){
            this.sections = this.$router.currentRoute.meta.sections
        },
        // When the section is clicked, jump to the section's position
        jump({id} = s){
            // get the section by its id
            let anchor = document.getElementById(id)
            // scroll to section's offsetTop - 50px smoothly
            window.scrollTo({
                top: anchor.offsetTop - 50,
                behavior: 'smooth'
            })
        },
        // During scrolling, change the active section in the menu
        onScroll(){
            // Get the position for each sections
            this.sections.forEach((item, index) => {
                let s = document.getElementById(item.id)
                if(window.scrollY >= s.offsetTop - 50){
                    this.activeIndex = index
                }
            })
        }
    },
    watch:{
        $route(){
            this.setSections()
        }
    },
    mounted() {
        this.$nextTick(this.setSections)
        addEventListener('scroll', this.onScroll)
    },
}
</script>

<style scoped>
#sections-menu{
    display: inline-block;
    width: fit-content;
}

/* sections-List position */
.sections-list{
    display: inline-block;
}

/* section-link styles */
.section-link{
    padding: 0 20px;
    display: block;
    position: relative;
    line-height: 50px;
    font-size: 20px;
    text-decoration: none;
    color: aliceblue;
    background-color: transparent;
    transition: background-color 0.5s ease;
    cursor: pointer;
}

/* activated and hover section's styles */
.active,
.section-link:hover{
    height: 50px;
    background-color: rgba(157, 94, 83, 0.8)
}
</style>